import HeaderProgress from "@components/Progress/HeaderProgress";
import React from "react";
import { Link } from "react-router-dom";
import { ReactComponent as FlagIcon } from "../../assets/icons/flag.svg";
import { ReactComponent as WalletIcon } from "../../assets/icons/wallet.svg";
import GetStartedIllustration from "../../assets/illustrations/get_started.png";

type PensionCalculatorProps = {};

const PensionCalculator: React.FC<PensionCalculatorProps> = () => {
  return (
    <section className="grow flex items-start md:items-center justify-center border-t-4 border-l-0 md:border-t-0 md:border-l-4 border-[#F4E34E] px-0 md:px-2 lg:px-0">
      <div className="max-w-full md:max-w-[846px] w-full md:rounded-3xl md:border md:border-pn_gray-200">
        <HeaderProgress currentStep={0} totalSteps={2} />

        <div className="flex flex-col md:flex-row md:items-stretch px-4 md:px-0 pb-2 md:pb-0">
          <div className="flex-1 md:py-6 md:pr-6 md:pl-8">
            <img
              src={GetStartedIllustration}
              alt="Get Started"
              className="rounded-2xl object-cover w-full h-full"
            />
          </div>

          <div className="flex-1 flex flex-col gap-y-6 md:py-6 md:pl-6 md:pr-8 mt-[31.63px] md:mt-0">
            <div className="md:p-4">
              <h2 className="text-pn-large-title">
                Start your pension from just €1 a day
              </h2>
            </div>

            <span className="block md:hidden text-pn-headline-regular">
              You can open a pension account in 24 hours if you:
            </span>

            <div className="flex flex-col gap-y-4">
              <div className="bg-white flex items-center gap-x-4 py-4 px-6 rounded-tr-md rounded-br-md border-l-4 border-[#F4E34E]">
                <div className="bg-pn_paper-3 rounded-full w-[40px] h-[40px] flex items-center justify-center">
                  <FlagIcon />
                </div>
                <div className="text-pn-body-regular">
                  You are a{" "}
                  <span className="text-pn-body-emphasis">
                    tax resident in Ireland
                  </span>
                </div>
              </div>

              <div className="bg-white flex items-center gap-x-4 py-4 px-6 rounded-tr-md rounded-br-md border-l-4 border-[#F4E34E]">
                <div className="bg-pn_paper-3 rounded-full w-[40px] h-[40px] flex items-center justify-center">
                  <WalletIcon />
                </div>
                <div className="flex-1">
                  You can contribute a{" "}
                  <span className="text-pn-body-emphasis">minimum of €300</span>{" "}
                  per year to long term savings (pension)
                </div>
              </div>

              <span className="hidden md:block text-center text-pn-callout-regular">
                Penny can show you what your pension could look like and how to
                start in a click
              </span>
            </div>
          </div>
        </div>

        <div className="mt-[17px] md:mt-0 flex flex-col md:flex-row md:items-center md:gap-x-2 gap-y-4 pb-[46.5px] md:pb-6 px-4 md:px-8 md:pt-2">
          <span className="hidden md:block text-pn-callout-regular text-pn_gray-600 flex-1">
            Your information is secure with Penny
          </span>
          <Link
            to="/pension-calculator/calculator"
            className="btn-primary-lg md:btn-primary-sm2 text-center"
          >
            Get Started
          </Link>
          <span className="block md:hidden text-center text-pn-callout-regular">
            Penny can show you what your pension could look like and how to
            start in a click
          </span>
        </div>
      </div>
    </section>
  );
};

export default PensionCalculator;
